import {anna, video} from '../../helper.js'

export const fill = function(varKey, varValue, question){
	// console.log('Fill mit ', varKey, varValue, question)


	let r = {}
	r.type = question.type

	r.answer = question.answer.replace(new RegExp(varKey, "g"), varValue)
	r.content = question.content.replace( new RegExp(varKey, "g"), varValue)

	r.alternatives = []

	question.alternatives && question.alternatives.forEach( (alternative, j, arrj) => {

		r.alternatives.push({
			answer: alternative.answer.replace(new RegExp(varKey, "g"), varValue),
			message: alternative.message.replace(new RegExp(varKey, "g"), varValue)
		})
	})

	console.log('returne: ', r)

	return r
}

export const evaluate = function(question, n){
	console.log('Evaluate ' + (n+1) + '. Frage', question)

	let r = {}
	r.type = question.type

	r.answer = anna(question.answer)
	r.content = video(anna(question.content, true))

	if(!r.alternatives){
		r.alternatives = []
	}

	question.alternatives && question.alternatives.forEach( (alternative, i, arrj) => {
		// console.log('durch die alternatives', alternative, i, arrj)

		r.alternatives.push({
			answer: anna(alternative.answer),
			message: video(anna(alternative.message, true))
		})
	})

	r.tryings = []

	return r
}



// WEBPACK FOOTER //
// ./src/questions/one/loader.js